// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2n2-A","left":"styles_left__1iukQ","desktopActions":"styles_desktopActions__pCBSJ","title":"styles_title__11odU"};